import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EditProfileModel } from '../model/editProfileModel';
import { UserRegister } from '../model/userRegister';
import { AlertService, AuthenticationService, UserService } from '../service';
import { ApplicationService } from '../service/application.service';
import { UploadfileService } from '../service/uploadfile.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  loader: boolean;
  message = '';
  uploadUserform: FormGroup;
  fileData: File = null;
  registerForm: FormGroup;
  editProfileModel: EditProfileModel;
  config: any;
  collection = { count: 20, data: [] };
  id: number;
  listBranch: any[];
  managerList: any[];
  listRegion: any[];
  listUserData: any[];
  flag: boolean;
  cssclass: string;
  cancelFlag: boolean;
  loading = false;
  submitted = false;
  returnUrl: string;
  id1: boolean = false;
  userId: string;
  alertclass: String = '';
  showMessage: string = '';
  roleList = [];
  titleList = [{ 'name': 'Mr' }, { 'name': 'Mrs' }, { 'name': 'Ms' }];
  userRegister: UserRegister;
  term: string;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private appService: ApplicationService,
    private uploadFileService: UploadfileService,
    private userService: UserService,) {
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.listUserData,
    };
  }

  ngOnInit() {
    this.loadBranch();
    this.loadManagerList();
    this.loadRegion();
    this.loadUserList();
    const filter = { $or: this.listUserData };
    this.userId = localStorage.getItem("userId")
    this.registerForm = this.formBuilder.group({
      roleList: ['', Validators.required],
      title: ['', Validators.required],
      firstName: ['', Validators.required],
      middleName: [null],
      lastName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      branchName: ['', [Validators.required]],
      employeeId: ['', [Validators.required, Validators.pattern("^[(A-Z){3},(/){1},(A-Z){3},(/){1},(0-9){4}]{12,12}$")]],
      repoManagerId: ['', [Validators.required, Validators.pattern("^[(A-Z){3},(/){1},(A-Z){3},(/){1},(0-9){4}]{12,12}$")]]

    });
    this.appService.getRoles().subscribe(response => {
      this.roleList = response;
    });
    this.uploadUserform = this.formBuilder.group({
      file: ['', Validators.required],
    });
  }
  get f() {
    return this.registerForm.controls;
  }

  onRegister(registerForm: FormGroup) {
    this.userRegister = {
      'role': this.registerForm.value.roleList, 'title': this.registerForm.value.title,
      'firstName': this.registerForm.value.firstName, 'middleName': this.registerForm.value.middleName,
      'lastName': this.registerForm.value.lastName,
      'phoneNumber': this.registerForm.value.phoneNumber,
      'email': this.registerForm.value.email,
      'branchName': this.registerForm.value.branchName,
      'employeeId': this.registerForm.value.employeeId,
      'repoManagerId': this.registerForm.value.repoManagerId,
    };

    this.submitted = true;
    if (this.registerForm.invalid) {
      this.cancelFlag = true;
      return;
    }
    this.loading = true;
    this.appService.userRegister(this.userRegister, this.userId).subscribe(response => {
      this.loading = false;
      this.showMessage = 'You have successfully registered.Please check your email';
      this.id1 = true;
      this.loadUserList();
      this.alertclass = 'alert alert-success';
      setTimeout(function () {
        this.id1 = false;
      }.bind(this), 3000);
    },
      error => {
        debugger
        this.loading = false;
        this.showMessage = error;
        this.id1 = true;
        this.alertclass = 'alert alert-warning';
        setTimeout(function () {
          this.id1 = false;
        }.bind(this), 3000);
      });
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  loadBranch() {
    this.appService.getBranchList().subscribe(data => {
      this.listBranch = data;
    });
  }

  loadManagerList() {
    this.appService.getManagerList().subscribe(data => {
      this.managerList = data;
    });
  }

  loadRegion() {
    this.appService.getRegionList().subscribe(data => {
      this.listRegion = data;
    });
  }
  loadUserList() {
    this.appService.getUserList().subscribe(data => {
      this.listUserData = data;
    });
  }
  deactivateUser(id) {
    this.appService.delete(id).subscribe(data => {
    });
  }

  onEditAction(id) {
    this.id = id;
    this.flag = true;
    this.cancelFlag = false;
    this.userService.findUserById(id).subscribe(data => {
    //  alert(JSON.stringify(data))
      this.registerForm.patchValue({
        roleList: data.role.roleName == null ? '' : data.role.roleName,
        title: data.title == null ? '' : data.title,
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        email: data.email,
        phoneNumber: data.phoneNumber,
        branchName: data.branchName == null ? '' : data.branchName,
        employeeId: data.employeeId,
        repoManagerId: data.managerId == null ? '' : data.managerId,

      });
    });
  }
  onReset() {
    this.flag = false;
    this.registerForm.patchValue({
      roleList: '',
      title: '',
      firstName: null,
      middleName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      branchName: '',
      employeeId: null,
      repoManagerId: ''
    });

  }
  onCancel() {
    this.flag = false;
    this.registerForm.removeControl('roleList')
    // this.registerForm.patchValue({
    //   roleList: '',
    //   title: '',
    //   firstName: null,
    //   middleName: null,
    //   lastName: null,
    //   email: null,
    //   phoneNumber: null,
    //   branchName: '',
    // });
  }
  onUpdate() {
    this.editProfileModel = {
      'id': this.id,
      'role': this.registerForm.value.roleList, 'title': this.registerForm.value.title,
      'firstName': this.registerForm.value.firstName, 'middleName': this.registerForm.value.middleName,
      'lastName': this.registerForm.value.lastName, 'phoneNumber': this.registerForm.value.phoneNumber,
      'email': this.registerForm.value.email,
      'branchName': this.registerForm.value.branchName,
      'employeeId': this.registerForm.value.employeeId,
      'repoManagerId': this.registerForm.value.repoManagerId
    };
    this.submitted = true;
    if (this.registerForm.invalid) {
      this.cancelFlag = true;
      return;
    }

    this.loading = true;
    this.userService.update(this.editProfileModel, this.id).subscribe(response => {
      this.loading = false;
      this.showMessage = "Your profile has been changed successfully!";
      this.id1 = true;
      this.alertclass = 'alert alert-success';
      setTimeout(function () {
        this.id1 = false;
        this.loadUserList();
      }.bind(this), 1000);
    },
      error => {
        this.loading = false;
        this.showMessage = error;
        this.id1 = true;
        this.alertclass = 'alert alert-warning';
      });  }
  pageChanged(event) {
    this.config.currentPage = event;
  }

  openDialog() {

    document.getElementById('userModal').style.display = 'block';

  }

  closeDialog() {

    document.getElementById('userModal').style.display = 'none';

  }

  uploadUsers() {
    this.loader = true;
    const formData = new FormData();
    formData.append('file', this.fileData);
    this.uploadFileService.uploadUserFile(localStorage.getItem("userId"), formData).subscribe(
      event => {
        //alert(JSON.stringify(event));
        this.loader = false;
        if (event != null) {
          this.message = 'User file uploaded successfuly ';
          this.flag = true;
          this.cssclass = 'alert alert-success'
          document.getElementById('userModal').style.display = 'none';
          setTimeout(function () {
            this.flag = false;
          }.bind(this), 3000);

        }
      },
      error => {
        this.loader = false;
        this.flag = true;
        this.cssclass = 'alert alert-danger'
        this.message = error;
        document.getElementById('userModal').style.display = 'none';
        setTimeout(function () {
          this.flag = false;
        }.bind(this), 3000);
      });
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.fileData = event.target.files[0];
    }
  }

}


